/**
 * #633: продолжение незакрытой серверной тренировки.
 *
 * После выгрузки мини-апа черновик в localStorage может пропасть, и тогда
 * идущую тренировку знает только сервер. Эти функции решают, относится ли
 * сессия к открытому дню и какой день программы открыть.
 */

/** Локальный день YYYY-MM-DD — так же, как workoutDateKey экрана тренировки. */
export function localDateKey(value: Date | string): string {
  const d = typeof value === 'string' ? new Date(value) : value
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/**
 * Индекс дня программы: день незакрытой сессии, если он есть в программе,
 * иначе выбранный в списке (?day=), иначе первый. Открыть другой день поверх
 * идущей сессии нельзя — новая сессия стёрла бы прежнюю вместе с подходами.
 */
export function resumeDayIndex(
  days: ReadonlyArray<{ id?: string | null }> | null | undefined,
  sessionProgramDayId: string | null | undefined,
  dayParam: string | null | undefined,
): number {
  if (sessionProgramDayId) {
    const idx = (days ?? []).findIndex((d) => d?.id === sessionProgramDayId)
    if (idx >= 0) return idx
  }
  const n = dayParam ? parseInt(dayParam, 10) : 0
  return Number.isFinite(n) && n >= 0 ? n : 0
}
